/* Dourabela Ateliê: comportamento do tema. Sem dependências. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  function money(c) {
    var v = (Number(c) || 0) / 100;
    return 'R$ ' + v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  var toastT;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* gavetas */
  var aberta = null, ultimoFoco = null;
  function abrir(id) {
    var d = document.getElementById(id); if (!d) return;
    if (aberta && aberta !== d) fechar();
    ultimoFoco = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    aberta = d;
    if (id === 'drw-cart' && !abrirSem) renderCart();
    var f = d.querySelector('input[type=search]') || d.querySelector('[data-close].hdr__btn');
    setTimeout(function () { f && f.focus(); }, 60);
  }
  function fechar() {
    if (!aberta) return;
    aberta.classList.remove('is-open'); aberta.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    aberta = null;
    ultimoFoco && ultimoFoco.focus && ultimoFoco.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); abrir(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); fechar(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { fechar(); fecharLb(); } });

  /* cabeçalho */
  var hdr = $('#hdr');
  function hdrScroll() { hdr && hdr.classList.toggle('is-solid', window.scrollY > 10); }
  // a barra da coleção gruda logo abaixo do cabeçalho: altura real, que muda entre celular e computador
  function hdrAltura() { hdr && document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px'); }
  hdrAltura(); window.addEventListener('resize', hdrAltura);
  if (window.ResizeObserver && hdr) new ResizeObserver(hdrAltura).observe(hdr);
  window.addEventListener('scroll', hdrScroll, { passive: true }); hdrScroll();

  /* revelar */
  /* bolinhas de cor do cartão: só as cores publicadas (as em rascunho levavam a página de erro) */
  function limparCores(raiz) {
    var on = window.SC_ON; if (!on || !Object.keys(on).length) return;
    $$('.sw', raiz).forEach(function (sw) {
      var ds = $$('a.sw__d', sw), vivas = 0;
      ds.forEach(function (d) { var h = (d.getAttribute('href') || '').split('/products/')[1]; if (h && !on[h.split('?')[0]]) d.remove(); else vivas++; });
      if (vivas < 2) sw.remove(); else sw.setAttribute('aria-label', vivas + ' cores');
    });
  }
  limparCores(document); window.scLimparCores = limparCores;

  /* foto de costas do cartão: só baixa em aparelho com mouse (no celular não há hover) */
  if (window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches) {
    var carregaAlt = function (im) { if (im.dataset.srcset) { im.srcset = im.dataset.srcset; im.src = im.dataset.src; delete im.dataset.srcset; } };
    var ioAlt = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { carregaAlt(e.target); ioAlt.unobserve(e.target); } }); }, { rootMargin: '300px' }) : null;
    var olhaAlt = function () { $$('.pc__alt[data-srcset]').forEach(function (im) { ioAlt ? ioAlt.observe(im) : carregaAlt(im); }); };
    olhaAlt(); window.scOlhaAlt = olhaAlt;
    document.addEventListener('mouseover', function (e) { var pc = e.target.closest && e.target.closest('.pc'); var im = pc && pc.querySelector('.pc__alt[data-srcset]'); if (im) carregaAlt(im); });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else { $$('.rv').forEach(function (el) { el.classList.add('is-in'); }); }

  /* carrosséis */
  $$('[data-rail]').forEach(function (rail) {
    var sec = rail.closest('section') || document;
    var passo = function () { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; };
    var p = sec.querySelector('[data-rail-prev]'), n = sec.querySelector('[data-rail-next]');
    p && p.addEventListener('click', function () { rail.scrollBy({ left: -passo() * 2, behavior: 'smooth' }); });
    n && n.addEventListener('click', function () { rail.scrollBy({ left: passo() * 2, behavior: 'smooth' }); });
  });

  /* sacola: abre na hora com o item (otimista) e confirma com o servidor em segundo plano */
  var cartCache = null;
  function contador(n) { $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); }); }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; }); }
  var cartTela = null;
  function desenhar(c) {
    cartTela = c;
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    if (!body) return c;
    contador(c.item_count);
    if (!c.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>Sua sacola está vazia.</p><a class="btn" href="/collections/novidades">Ver novidades</a></div><div data-cart-rec></div>';
      foot.hidden = true; recomendar(null); return c;
    }
    body.innerHTML = c.items.map(function (it, i) {
      var t = it.product_title, v = it.variant_title || '', pend = it._pend;
      return '<div class="cart-it' + (pend ? ' is-pend' : '') + '"><a class="cart-it__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 240)) + '" alt="" width="240" height="336">' : '') + '</a>' +
        '<div><a class="cart-it__t" href="' + esc(it.url) + '">' + esc(t) + '</a><p class="cart-it__v">' + esc(v) + '</p>' +
        '<div class="cart-it__row"><div class="qty"><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity - 1) + '" aria-label="Diminuir"' + (pend ? ' disabled' : '') + '>−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity + 1) + '" aria-label="Aumentar"' + (pend ? ' disabled' : '') + '>+</button></div>' +
        '<strong>' + money(it.final_line_price) + '</strong></div>' +
        '<button type="button" class="cart-it__rm" data-q="' + (i + 1) + '" data-v="0" style="margin-top:10px"' + (pend ? ' disabled' : '') + '>Remover</button></div></div>';
    }).join('') + '<div data-cart-rec></div>';
    $('[data-cart-total]').textContent = money(c.total_price);
    foot.hidden = false;
    recomendar(c);
    return c;
  }
  function renderCart(cart) {
    if (cart) { cartCache = cart; return Promise.resolve(desenhar(cart)); }
    if (cartCache) desenhar(cartCache);
    return getCart().then(desenhar);
  }

  /* "Combine com": produtos relacionados ao último item da sacola (ou vestidos, com a sacola vazia) */
  var recCache = {}, recAtual = [];
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rec-add]'); if (!b) return;
    e.preventDefault();
    var par = b.getAttribute('data-rec-add').split('|'), p = recAtual[+par[0]]; if (!p) return;
    var v = p.variants.find(function (x) { return String(x.id) === par[1]; }); if (!v) return;
    var im = p.featured_image || (p.images && p.images[0]) || ''; if (typeof im === 'object') im = im.src || '';
    var cents = function (x) { return typeof x === 'number' ? x : Math.round(parseFloat(x || 0) * 100); };
    b.classList.add('is-on');
    addOtimista({ id: p.id, title: p.title, handle: p.handle, featured_image: im }, { id: v.id, title: v.title, price: cents(v.price) })
      .catch(function (x) { toast(x.message); });
  });
  function recomendar(c) {
    var box = $('[data-cart-rec]'); if (!box) return;
    var noCarrinho = {}; (c && c.items || []).forEach(function (it) { noCarrinho[it.product_id] = 1; });
    var ult = c && c.items && c.items.length ? c.items[0].product_id : null;
    var chave = ult || 'vazia';
    var url = ult ? '/recommendations/products.json?product_id=' + ult + '&limit=8&intent=related' : '/collections/vestidos/products.json?limit=8';
    var cents = function (x) { return typeof x === 'number' ? x : Math.round(parseFloat(x || 0) * 100); };
    var pinta = function (lista) {
      var ps = lista.filter(function (p) { return !noCarrinho[p.id] && (p.variants || []).some(function (v) { return v.available !== false; }); }).slice(0, 3);
      if (!ps.length) { box.innerHTML = ''; return; }
      recAtual = ps;
      box.innerHTML = '<div class="crec"><p class="crec__t">Adicione também</p>' + ps.map(function (p, k) {
        var v0 = p.variants[0], preco = cents(p.price != null ? p.price : v0.price);
        var de = cents(p.compare_at_price != null ? p.compare_at_price : v0.compare_at_price);
        var im = p.featured_image || (p.images && p.images[0]) || ''; if (typeof im === 'object') im = im.src || '';
        return '<div class="crec__it"><a class="crec__img" href="/products/' + esc(p.handle) + '">' + (im ? '<img src="' + esc(img(im, 200)) + '" alt="" width="200" height="280" loading="lazy">' : '') + '</a>' +
          '<div class="crec__info"><span class="crec__n">' + esc(String(p.title).split(' - ')[0]) + '</span><span class="crec__p">' + (de > preco ? '<s>' + money(de) + '</s>' : '') + money(preco) + '</span>' +
          '<span class="crec__l">Toque no tamanho para adicionar</span><div class="crec__tams">' + p.variants.map(function (v) {
            return '<button type="button" data-rec-add="' + k + '|' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>' + esc(v.option1 || v.title) + '</button>';
          }).join('') + '</div></div></div>';
      }).join('') + '</div>';
    };
    if (recCache[chave]) return pinta(recCache[chave]);
    fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (j) { recCache[chave] = j.products || []; if ($('[data-cart-rec]')) pinta(recCache[chave]); }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.getAttribute('data-q'), quantity: +b.getAttribute('data-v') }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { b.disabled = false; });
  });
  /* fila: duas adições ao mesmo tempo numa sacola nova criam duas sacolas na Shopify e a primeira se perde */
  var filaCart = Promise.resolve();
  function addCart(id, qty) {
    var r = filaCart.then(function () { return addCartJa(id, qty); });
    filaCart = r.catch(function () {});
    return r;
  }
  function addCartJa(id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Não foi possível adicionar.'); return j; }); });
  }
  /* adiciona mostrando o item na sacola imediatamente; P = JSON do produto, v = variante */
  function addOtimista(P, v) {
    var c = JSON.parse(JSON.stringify(cartTela || cartCache || { items: [], item_count: 0, total_price: 0 }));
    var it = c.items.find(function (x) { return x.variant_id === v.id || x.id === v.id; });
    if (it) { it.quantity += 1; it.final_line_price += v.price; it._pend = 1; }
    else {
      var im = (v.featured_image && v.featured_image.src) || P.featured_image || '';
      c.items.unshift({ id: v.id, variant_id: v.id, product_id: P.id, product_title: P.title, variant_title: v.title, url: '/products/' + P.handle + '?variant=' + v.id, image: im, quantity: 1, final_line_price: v.price, _pend: 1 });
    }
    c.item_count += 1; c.total_price += v.price;
    desenhar(c);
    var d = document.getElementById('drw-cart');
    if (d && !d.classList.contains('is-open')) { abrirSem = 1; abrir('drw-cart'); abrirSem = 0; }
    var pend = addCart(v.id); addOtimista.n = (addOtimista.n || 0) + 1;
    return pend.then(function () { if (--addOtimista.n) return; return getCart().then(desenhar); })
      .catch(function (x) { addOtimista.n = Math.max(0, addOtimista.n - 1); getCart().then(desenhar); throw x; });
  }
  var abrirSem = 0;
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick]'); if (!q) return;
    e.preventDefault(); q.disabled = true;
    addCart(q.getAttribute('data-quick')).then(function () { q.disabled = false; abrir('drw-cart'); })
      .catch(function (err) { q.disabled = false; toast(err.message); });
  });

  /* busca instantânea */
  var si = $('[data-search-input]'), sr = $('[data-search-res]'), sg = $('[data-search-sug]'), st;
  si && si.addEventListener('input', function () {
    clearTimeout(st);
    var q = si.value.trim();
    if (q.length < 2) { sr.innerHTML = ''; sg.hidden = false; return; }
    st = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); }).then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          sg.hidden = ps.length > 0;
          sr.innerHTML = ps.length ? ps.map(function (p) {
            return '<a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image, 160)) + '" alt="" width="60" height="84">' : '<span></span>') + '<div><b>' + esc(p.title) + '</b><span>' + money(Math.round(parseFloat(p.price) * 100)) + '</span></div></a>';
          }).join('') + '<p style="margin-top:18px"><a class="lnk" href="/search?type=product&q=' + encodeURIComponent(q) + '">Ver todos os resultados</a></p>'
            : '<p style="color:var(--ink3)">Nenhuma peça encontrada para "' + esc(q) + '".</p>';
        });
    }, 220);
  });

  /* coleção: ordenação e colunas */
  var sort = $('[data-sort]');
  sort && sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString();
  });
  var grid = $('[data-grid]');
  if (grid) {
    var salvo = null; try { salvo = localStorage.getItem('sc_cols'); } catch (e) {}
    var aplica = function (n) {
      grid.classList.toggle('grid--3', false);
      grid.style.gridTemplateColumns = n === '2' ? 'repeat(2,1fr)' : '';
      $$('[data-cols]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cols') === n ? 'true' : 'false'); });
    };
    $$('[data-cols]').forEach(function (b) { b.addEventListener('click', function () { var n = b.getAttribute('data-cols'); aplica(n); try { localStorage.setItem('sc_cols', n); } catch (e) {} }); });
    if (salvo) aplica(salvo);
  }

  /* produto */
  function iniciarPdp() {
    var pdp = $('[data-pdp]');
    if (!pdp) return;
    var P = JSON.parse($('[data-product-json]').textContent);
    var conf = JSON.parse($('[data-pdp-conf]').textContent);
    var form = $('[data-form]'), vidIn = $('[data-vid]'), err = $('[data-err]');
    var track = $('[data-track]'), slides = $$('[data-sl]'), thumbs = $$('[data-th]'), dots = $$('.gal__dots i');

    var idxAtual = 0;
    function irPara(i, suave) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: suave === false ? 'auto' : 'smooth' });
    }
    function marcar(i) {
      idxAtual = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    track && track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idxAtual) marcar(i);
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { irPara(k); }); });
    var pv = $('[data-prev]', pdp), nx = $('[data-next]', pdp);
    pv && pv.addEventListener('click', function () { irPara(Math.max(0, idxAtual - 1)); });
    nx && nx.addEventListener('click', function () { irPara(Math.min(slides.length - 1, idxAtual + 1)); });

    function selecionados() {
      return P.options.map(function (o, i) { var r = form.querySelector('input[name="opt' + i + '"]:checked'); return r ? r.value : null; });
    }
    function achar(sel) {
      return P.variants.find(function (v) { return v.options.every(function (x, i) { return sel[i] === x; }); });
    }
    function disponibilidade(sel) {
      P.options.forEach(function (o, i) {
        $$('input[name="opt' + i + '"]', form).forEach(function (inp) {
          var ok = P.variants.some(function (v) {
            return v.available && v.options.every(function (x, k) { return k === i ? x === inp.value : (sel[k] == null || x === sel[k]); });
          });
          inp.disabled = !ok;
        });
      });
    }
    function inst(c) { return '12x de ' + money(Math.round(c * 1.2988 / 12)); }
    function atualizar() {
      var sel = selecionados();
      disponibilidade(sel);
      var v = sel.every(Boolean) ? achar(sel) : null;
      err.textContent = '';
      if (v) {
        vidIn.value = v.id;
        $('[data-price]').textContent = money(v.price);
        if ($('[data-inst]')) $('[data-inst]').textContent = inst(v.price);
        var sp = $('[data-stk-price]'); if (sp) sp.textContent = money(v.price);
        if (v.featured_image) {
          var k = slides.findIndex(function (s) { return +s.getAttribute('data-img-id') === v.featured_image.id; });
          if (k >= 0) irPara(k);
        }
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      if (conf.tam >= 0 && sel[conf.tam]) destacarTam(sel[conf.tam]);
      return v;
    }
    form.addEventListener('change', atualizar);
    atualizar();

    function exigir() {
      var sel = selecionados();
      var falta = P.options.find(function (o, i) { return !sel[i]; });
      if (falta) {
        err.textContent = 'Escolha o ' + (falta.toLowerCase ? falta.toLowerCase() : 'tamanho') + ' para continuar.';
        var g = form.querySelector('[data-opt="' + P.options.indexOf(falta) + '"]');
        g && g.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return null;
      }
      var v = achar(sel);
      if (!v || !v.available) { err.textContent = 'Esta combinação está esgotada.'; return null; }
      return v;
    }
    var addBtn = $('[data-add]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = exigir(); if (!v) return;
      addOtimista(P, v).catch(function (x) { err.textContent = x.message; toast(x.message); });
    });
    $('[data-buy]').addEventListener('click', function () {
      var v = exigir(); if (!v) return;
      this.disabled = true;
      var b = this;
      addCart(v.id).then(function () { location.href = window.SC.checkout; })
        .catch(function (x) { b.disabled = false; err.textContent = x.message; });
    });

    /* barra fixa no celular */
    var stk = $('[data-stk]'), btns = $('.pi__btns');
    if (stk && btns && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { stk.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(btns);
      $('[data-stk-add]').addEventListener('click', function () {
        var v = exigir(); if (!v) return;
        addOtimista(P, v).catch(function (x) { toast(x.message); });
      });
    }

    /* tabela de medidas: destaca a linha do tamanho; tocar numa linha escolhe o tamanho */
    function destacarTam(t) {
      $$('.tmc__r').forEach(function (r) { r.classList.toggle('is-sel', r.getAttribute('data-size') === t); });
    }
    $$('[data-tm] .tmc__r').forEach(function (r) {
      function escolher() {
        var t = r.getAttribute('data-size');
        destacarTam(t);
        var inp = $$('input[name="opt' + conf.tam + '"]', form).find(function (i) { return i.value === t; });
        if (inp && !inp.disabled) { inp.checked = true; atualizar(); }
      }
      r.addEventListener('click', escolher);
      r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); escolher(); } });
    });

    /* zoom */
    var lb = $('#lb'), lbt = $('[data-lb-track]');
    slides.forEach(function (s, k) {
      s.addEventListener('click', function () {
        if (!lbt.childElementCount) lbt.innerHTML = slides.map(function (x) { var im = x.querySelector('img'); return '<img src="' + esc(im.getAttribute('data-zoom')) + '" alt="' + esc(im.alt) + '" loading="lazy">'; }).join('');
        lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(function () { lbt.scrollTo({ left: lbt.clientWidth * k, behavior: 'auto' }); });
      });
    });
    $('[data-lb-close]').addEventListener('click', fecharLb);
  }
  iniciarPdp();

  /* troca de cor sem recarregar: busca só a seção do produto da outra cor e troca no lugar */
  var pdpCache = {};
  function secaoPdp() { var el = $('[data-pdp]'); return el && el.closest('.shopify-section'); }
  function buscarPdp(url) {
    var sec = secaoPdp(); if (!sec) return Promise.reject();
    var id = sec.id.replace('shopify-section-', '');
    var u = url.split('#')[0]; u += (u.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
    if (!pdpCache[u]) pdpCache[u] = fetch(u).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(aquecerFotos).catch(function (e) { delete pdpCache[u]; throw e; });
    return pdpCache[u];
  }
  // baixa e decodifica as fotos visíveis da outra cor ANTES da troca, para não piscar quadro vazio (teto de 1,5 s)
  function aquecerFotos(html) {
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var ims = Array.prototype.slice.call(tmp.querySelectorAll('[data-sl="0"] img, [data-th] img, .color__img img'));
    var ps = ims.map(function (im) {
      var i = new Image();
      if (im.getAttribute('sizes')) i.sizes = im.getAttribute('sizes');
      if (im.getAttribute('srcset')) i.srcset = im.getAttribute('srcset');
      i.src = im.getAttribute('src');
      return (i.decode ? i.decode() : new Promise(function (ok) { i.onload = i.onerror = ok; })).catch(function () {});
    });
    return Promise.race([Promise.all(ps), new Promise(function (ok) { setTimeout(ok, 1500); })]).then(function () { return html; });
  }
  function trocarPdp(url, empurrar) {
    var sec = secaoPdp(); if (!sec) { location.href = url; return; }
    sec.classList.add('is-trocando');
    return buscarPdp(url).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var nova = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
      if (!nova || !nova.querySelector('[data-pdp]')) throw new Error('sem pdp');
      nova.querySelectorAll('.rv').forEach(function (el) { el.classList.add('is-in'); });
      nova.querySelectorAll('img[loading="lazy"]').forEach(function (im) { if (im.closest('[data-th], .color__img')) im.loading = 'eager'; });
      sec.replaceWith(nova);
      if (empurrar) history.pushState({ pdp: 1 }, '', url);
      var t = nova.querySelector('h1'); if (t) document.title = t.textContent.trim() + ' | Dourabela Ateliê';
      iniciarPdp();
      limparCores(nova);
      setTimeout(preCarregarCores, 300);
      if (window.scOlhaAlt) window.scOlhaAlt();
      var g = $('[data-pdp]'); if (g && g.getBoundingClientRect().top < 0) window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - 90 });
    }).catch(function () { location.href = url; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.colors a.color');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var href = a.getAttribute('href'); if (!href || href === '#') return;
    e.preventDefault();
    if (a.classList.contains('is-on')) return;
    trocarPdp(href, true);
  });
  // pré-carrega a outra cor ao passar o dedo/mouse, para a troca ser instantânea
  ['mouseover', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var a = e.target.closest && e.target.closest('.colors a.color:not(.is-on)');
      if (a && a.getAttribute('href') && a.getAttribute('href') !== '#') buscarPdp(a.getAttribute('href')).catch(function () {});
    }, { passive: true });
  });
  // com a página parada, já deixa as outras cores prontas (são poucas), para a troca ser instantânea
  function preCarregarCores() {
    document.querySelectorAll('.colors a.color:not(.is-on)').forEach(function (a) {
      var h = a.getAttribute('href'); if (h && h !== '#') buscarPdp(h).catch(function () {});
    });
  }
  if (secaoPdp()) (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(preCarregarCores, { timeout: 2500 });
  window.addEventListener('popstate', function () { if (secaoPdp() && /\/products\//.test(location.pathname)) trocarPdp(location.pathname + location.search, false); });
  function fecharLb() {
    var lb = $('#lb'); if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = '';
  }

  /* contador inicial: a página pode vir do cache */
  getCart().then(function (c) { contador(c.item_count); }).catch(function () {});
})();
